export function initTooltips() {
    const tooltips = document.querySelectorAll('.js-tooltip:not([data-tooltip-initialized])');

    tooltips.forEach(tooltip => {
        tooltip.setAttribute('data-tooltip-initialized', 'true');
        tooltip.addEventListener('mouseenter', function() {
            const tooltipText = this.getAttribute('data-tooltip');
            const tooltipBubble = document.createElement('div');
            tooltipBubble.className = 'tooltip-bubble';
            tooltipBubble.textContent = tooltipText;
            this.appendChild(tooltipBubble);
            updateMaxWidthEvent(tooltipBubble, this);
        });

        tooltip.addEventListener('mouseleave', function() {
            const tooltipBubble = this.querySelector('.tooltip-bubble');
            if (tooltipBubble) {
                tooltipBubble.remove();
            }
        });

        tooltip.addEventListener('click', function(e) {
          if (this.closest('.js-detail')) {
            const tooltipText = this.getAttribute('data-tooltip');
            const flagsWrapper = this.closest('.flags-wrapper.multiple');
            this.remove();
            if (flagsWrapper && tooltipText) {
              flagsWrapper.appendChild(document.createTextNode(', ' + tooltipText));
            }
            return;
          }
          e.stopPropagation();
          e.preventDefault();
        });

    });
}

function updateMaxWidthEvent(tooltipBubble, tooltipThis) {

    const windowWidth = document.documentElement.clientWidth;
    const featuredImageDetail = document.querySelector(".article-detail-featured-image");
    const featuredImageList = document.querySelector(".article-block-photo");
    const featuredImageSecond = document.querySelector(".article-photo");
    const eventThemeGroupDetail = document.querySelector(".article-detail-table");
    const eventThemeGroupList = document.querySelector(".article-wrapper");
    const eventThemeGroupSecond = document.querySelector(".article-other-info");
    const moreCountries = tooltipThis;

    let featuredImage = null;
    if (featuredImageDetail) {
        featuredImage = featuredImageDetail;
    } else if (featuredImageList) {
        featuredImage = featuredImageList;
    } else if (featuredImageSecond) {
        featuredImage = featuredImageSecond;
    }

    let eventThemeGroup = null;
    if (eventThemeGroupDetail) {
        eventThemeGroup = eventThemeGroupDetail;
    } else if (eventThemeGroupList) {
        eventThemeGroup = eventThemeGroupList;
    } else if (eventThemeGroupSecond) {
        eventThemeGroup = eventThemeGroupSecond;
    }

    if (!eventThemeGroup || !moreCountries || !tooltipBubble || !featuredImage) {
        return;
    }

    const eventThemeGroupRect = eventThemeGroup.getBoundingClientRect();
    const moreCountriesRect = moreCountries.getBoundingClientRect();
    const featuredImageRect = featuredImage.getBoundingClientRect();

    if (windowWidth < 750) {
        tooltipBubble.style.left = `${eventThemeGroupRect.left - moreCountriesRect.left}px`;
        tooltipBubble.style.width = `${eventThemeGroup.offsetWidth}px`;
        tooltipBubble.style.maxWidth = "";
        tooltipBubble.style.setProperty('--tooltip-left', `${moreCountriesRect.left + 6}px`);
    } else if (windowWidth >= 750 && windowWidth < 800) {
        tooltipBubble.style.left = `${eventThemeGroupRect.left - moreCountriesRect.left}px`;
        tooltipBubble.style.width = `${eventThemeGroup.offsetWidth}px`;
        tooltipBubble.style.maxWidth = "";
        tooltipBubble.style.setProperty('--tooltip-left', `${moreCountriesRect.left - featuredImageRect.width - 6 }px`);
    } else {
        tooltipBubble.style.width = "";
        const availableWidth = Math.max(0, eventThemeGroupRect.right - moreCountriesRect.left);
        if (availableWidth > 0) {
            tooltipBubble.style.maxWidth = `${availableWidth - 14}px`;
        }
        tooltipBubble.style.left = "";
        tooltipBubble.style.top = "";
    }
}

document.addEventListener('DOMContentLoaded', function() {
    initTooltips();
});
